const wirkConfig = await fetch('/config.json').then((response) => response.json())

export const getWirkUrl = (key: string) => {
  try {
    const url = wirkConfig['WebApps'][key].URL
    return url
  } catch (e) {
    throw new Error("URL don't exist")
  }
}

export const getWirkConfig = (key1: string, key2: string) => {
  try {
    const url = wirkConfig['WebApps'][key1][key2]
    return url
  } catch (e) {
    throw new Error("Config don't exist")
  }
}
